<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column has-text-centered">
                <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
                <h1 class="title" v-if="!getLoaderStatus">Messages from: {{ user.name }}</h1>
            </div>
        </div>
        <div class="columns is-centered" v-if="!getLoaderStatus">
            <div class="column is-half">
                <span v-for="mail in mails" v-html="mail.body"></span>
            </div>
        </div>
        <div class="columns is-centered" v-if="!getLoaderStatus">
            <div class="column is-half">
                <div class="field">
                    <label class="label">Message</label>
                    <div class="control">
                        <textarea class="textarea" v-model="newMessage.body" placeholder="Type your message here"></textarea>
                    </div>
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-link" @click="reply()">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiGmail from './../../../../../api/apiGmail'
    import apiUsers from './../../../../../api/apiUsers'
    import appLoader from 'vue-spinner/src/ClipLoader'
    export default {
        components: {
            appLoader
        },
        data(){
            return {
                options: this.$store.getters.getOptions,
                user: '',
                mails: [],
                newMessage: {
                    email_id: this.$route.params.id,
                    to: '',
                    body: ''
                }
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
        },
        methods: {
            reply() {
                this.$store.dispatch('setStatusLoading')
                apiGmail
                    .sendReplyRequest(this.newMessage)
                    .then((response) => {
                        this.mails = response.data
                        this.$store.dispatch('setStatusLoaded')

                    })
                    .catch(error => console.log(error))
            }
        },
        created(){
            this.$store.dispatch('setStatusLoading')
            apiGmail
                .getMailByIdRequest(this.$route.params.id)
                .then((response) => {
                    this.mails = response.data
                    this.$store.dispatch('setStatusLoaded')

                })
                .catch(error => console.log(error))
            apiUsers
                .userRequest(this.$store.getters.getMessagesUserId)
                .then((response) => {
                    this.user = response.data
                    this.newMessage.to = this.user.email
                })
                .catch(error => console.log(error))
        }
    }
</script>

<style scoped>
    .has-text-centered {
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Messages/Thread/Thread.vue